import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { MdOutlineCloudUpload } from 'react-icons/md'; // Cloud-Based Model Deployment
import { MdOutlineDevices } from 'react-icons/md'; 
import img1 from "../../../../assets/img/Services/AI&ML/5169.jpg"

export default function MainSection4() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Deployment at Scale
            </h1>
            <p className="text-lg text-gray-600">
            Deploy AI/ML models on cloud platforms (Azure, AWS, Alibaba Cloud, GCP) and edge devices for seamless integration.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineCloudUpload className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Cloud-Based Model Deployment</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Deploy AI/ML solutions on platforms like Azure, AWS, GCP, and Alibaba Cloud for scalable and reliable integration.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineDevices className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900"> Edge Device Integration</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Enable real-time AI functionalities by deploying models on edge devices for seamless operations.
              </p>
            </div>

      
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}